import Image from "next/image";
import MuxPlayer from "components/Tiles/commonComponents/MuxPlayer";

type FeatBlockProps = {
  header: string;
  subHeader: string;
  rows: {
    title: string;
    subtitle: string;
    icon: string;
  }[];
  videoUrl: string;
  bgColor: string;
  titleTag: React.ElementType;
  useGifThumbnail?: boolean;
};

const FeatBlocks = ({
  header,
  subHeader,
  rows = [],
  videoUrl,
  bgColor,
  titleTag = "p",
  useGifThumbnail
}: FeatBlockProps) => {
  const firstRow = rows[0];
  const secondRow = rows[1];
  const thirdRow = rows[2];

  const TitleTag = titleTag;

  return (
    <>
      <section id="FeatBlock-33" className="@container">
        <section id="textcontent-intro" style={{ backgroundColor: bgColor }}>
          <div className="m-auto max-w-[1600px] px-6 pb-52 pt-20 @2xl:px-20">
            <div className="m-auto w-full max-w-[800px] text-center">
              <TitleTag className="tile-main-header font-heading ">{header}</TitleTag>
              <p className="tile-subtitle [text-wrap:balance]">{subHeader}</p>
            </div>

            <div className="mt-12  w-full">
              <div className="grid grid-cols-10 gap-2 text-primary-700 @7xl:gap-6">
                {!!firstRow && (
                  <div className="col-span-10 mb-8 flex flex-col items-center justify-start rounded-2xl bg-[#F3F1E6] p-4 py-12 text-center @2xl:p-8 @3xl:col-span-6 @7xl:p-12">
                    <Image src={firstRow.icon} width={64} height={64} alt="Award-winning" className="mb-6" />
                    <h2 className="mb-4 font-heading text-2xlt @7xl:text-3xlt">{firstRow.title}</h2>
                    <p className="max-w-[440px] text-md leading-6 text-primary-700 [text-wrap:balance]">
                      {firstRow.subtitle}
                    </p>
                  </div>
                )}

                {!!secondRow && (
                  <div className="col-span-10 mb-8 flex flex-col items-center justify-start rounded-2xl bg-[#F3F1E6] p-4 py-8 text-center @2xl:p-8 @3xl:col-span-4 @7xl:p-12">
                    <Image src={secondRow.icon} width={64} height={64} alt="2800+ projects" className="mb-6" />
                    <h2 className="mb-4 font-heading text-2xl @7xl:text-3xl">{secondRow.title}</h2>
                    <p className="max-w-[440px] text-md  leading-6 text-primary-700 [text-wrap:balance]">
                      {secondRow.subtitle}
                    </p>
                  </div>
                )}
              </div>
              <div className="grid grid-cols-10 gap-2 text-primary-700 @7xl:gap-6">
                <div className="rounded-2xlt relative col-span-10 mb-8 flex min-h-[200px] flex-col items-center justify-start overflow-hidden bg-transparent text-center @3xl:col-span-4">
                  {!!videoUrl && (
                    <MuxPlayer
                      playbackId={videoUrl}
                      loop
                      muted
                      autoPlay
                      useGifThumbnail={useGifThumbnail}
                      className="border-primary-[#E8ECED] z-10  h-full w-full overflow-hidden rounded-xl border object-cover "
                    />
                  )}
                </div>

                {!!thirdRow && (
                  <div className="col-span-10 mb-8 flex flex-col items-center justify-start rounded-2xl bg-[#E8E8D9] p-4 py-12 text-center @2xl:p-8 @3xl:col-span-6 @7xl:p-12">
                    <Image src={thirdRow.icon} width={64} height={64} alt="Award-winning" className="mb-6" />
                    <h2 className="mb-4 font-heading text-2xlt @7xl:text-3xlt">{thirdRow.title}</h2>
                    <p className="max-w-[440px] text-md  leading-6 text-primary-700 [text-wrap:balance]">
                      {thirdRow.subtitle}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default FeatBlocks;
